// extracted by mini-css-extract-plugin
export default {"border":"AaFeBj","a11yFocus":"F1gZUS","a11YFocus":"F1gZUS","submitButton":"x8pPZ9"};